module.exports = __webpack_public_path__ + "img/bgscore2.f8c46432.png";